module.exports = __webpack_public_path__ + "media/images/mime_types/file-excel-o-2191651ed4a76395ca0cbbfb02c067fc.png";